import { useTranslation } from 'react-i18next';

import Typography, { TAG, VARIANT } from '~/components/isolated/Typography';

import styles from './OrderInfo.module.scss';

/**
 * OrderInfo component
 * Displays informational message about delivery methods selection
 */
const OrderInfo = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <Typography
        variant={VARIANT['Text 100/Regular High']}
        as={TAG.p}
        className={styles.text}
      >
        {t('phrases:deliveryInfoOnCheckoutPage')}
      </Typography>
    </div>
  );
};

export default OrderInfo;
